"use strict";

exports.__esModule = true;
exports.LayoutElementTitle = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LayoutElementTitle = exports.LayoutElementTitle = _styledComponents["default"].span.withConfig({
  displayName: "styles__LayoutElementTitle",
  componentId: "sc-198kdp-0"
})(["font-weight:bold;font-size:medium;"]);